import { useEffect, useState } from 'react';
import { publicApi } from '../api/client';

export function usePublicItem(entity, id) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!id) return;
    let alive = true;
    setLoading(true);
    publicApi.list(entity)
      .then((d) => {
        if (alive) {
          const item = d.find(item => item.id === id);
          setData(item || null);
        }
      })
      .catch((e) => { if (alive) setErr(e?.message || 'Xəta'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [entity, id]);

  return { data, loading, err };
}
